import React, { useRef, useState, useEffect } from "react"

import AudioBlock from "./audioBlock"

const AudioGalleryBlock = ({ assets }) => {
  const listRef = useRef(null)
  const [isScrollList, setIsScrollList] = useState(false)
  const [scrollOverlayOpacity, setScrollOverlayOpacity] = useState('1')

  useEffect(() => {
    const list = listRef.current

    if (list.scrollHeight <= list.clientHeight) {
      return
    }

    setIsScrollList(true)

    const onScroll = () => {
      if (list.scrollHeight - list.scrollTop - list.clientHeight > 150) {
        setScrollOverlayOpacity(1)
        return
      }

      setScrollOverlayOpacity((list.scrollHeight - list.scrollTop - list.clientHeight) / 150)
    }

    list.addEventListener("scroll", onScroll, { passive: true })

    return () => list.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <div className="relative overflow-hidden border tro-body-block-content__audio-gallery col-span-full tablet:col-start-4 tablet:col-span-6 isolate rounded-xl">
      {isScrollList && (
        <div className="absolute inset-0 top-auto z-10 w-full h-16 pointer-events-none bg-gradient-to-t from-brand-lightgrey" style={{ opacity: scrollOverlayOpacity }} />
      )}

      <ul ref={listRef} className="overflow-y-scroll tro-body-block-content__audio-gallery-player max-h-56 medium:max-h-60 overscroll-contain">
        {assets.map((asset, index) => {
          const { title, assetUrl } = asset

          return (
            <li key={index} className={index !== assets.length - 1 ? "border-b" : ""}>
              <AudioBlock title={title} assetUrl={assetUrl} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default AudioGalleryBlock
